export default __webpack_public_path__ + "static/media/image20.e8336e79.jpg";